import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'react-html-parser';
import format from 'string-template';

import { CoachInfo as CoachInfoModel } from '../../../../../../../Model/CoachInfo';
import Coach from '../../../../../../../Model/Coach';
import InternalAssignment from '../../../../../../../Model/InternalAssignment';
import { AssignmentRole } from '../../../../../../../utils/internalAssignments';
import useComponentMounted from '../../../../../../../hooks/useComponentMounted';
import LoadingOverlay from '../../../../../LoadingOverlay';

import StructuredCoachInfoView from './StructuredCoachInfoView';
import {
  InfoSection,
  InfoContainer,
} from './styles';
import texts from './texts.json';

const CoachInfo = ({
  coachId,
  coachName,
}) => {
  const [coachInfo, setCoachInfo] = useState();
  const [isNewCoachInfoView, setIsNewCoachInfoView] = useState(false);
  const [assignedCAMName, setAssignedCAMName] = useState('');
  const [isEnrolledAt, setIsEnrolledAt] = useState(null);
  const isComponentMountedRef = useComponentMounted();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadCoachInfo = async () => {
      setIsLoading(true);
      const coachInfoCollection = await CoachInfoModel.getCoachInfosByCoachId(coachId);
      const camInternalAssignment = await InternalAssignment.getCurrentAssignmentOfCoachByRole(
        coachId, AssignmentRole.CAM,
      );
      const coachDoc = await Coach.getCoachById(coachId);
      const currentCoachInfo = coachInfoCollection.docs.find((doc) => doc.current);

      if (isComponentMountedRef.current) {
        setIsEnrolledAt(coachDoc.isEnrolledAt);
        if (camInternalAssignment.hasDocs) {
          setAssignedCAMName(camInternalAssignment.docs[0].userName);
        }
        if (currentCoachInfo) {
          setCoachInfo(currentCoachInfo);
          setIsNewCoachInfoView(true);
        } else if (!coachInfoCollection.hasDocs && !coachName) {
          setCoachInfo(format(texts.coachName, { coachName: coachDoc.name }));
        } else {
          setCoachInfo(coachInfoCollection.docs[0]?.coachInfoNote || format(texts.coachName, { coachName }));
        }
      }
      setIsLoading(false);
    };

    loadCoachInfo();
  }, [coachId, coachName, isComponentMountedRef]);

  return (
    <>
      {isNewCoachInfoView ? (
        <StructuredCoachInfoView
          data={coachInfo}
          assignedCAMName={assignedCAMName}
          isEnrolledAt={isEnrolledAt?.toDate()}
        />
      ) : (
        <InfoSection>
          <InfoContainer>
            {parse(coachInfo)}
          </InfoContainer>
        </InfoSection>
      )}
      <LoadingOverlay isLoading={isLoading} />
    </>
  );
};

CoachInfo.propTypes = {
  coachId: PropTypes.string.isRequired,
  coachName: PropTypes.string.isRequired,
};

export default CoachInfo;
